import { District } from "@hubcapp/views/AreasAndPrices/types";
import { RowData } from "@hubcapp/components/DistrictsTable/types";

export enum ViewMode {
  View = "view",
  Edit = "edit",
}

export type DistrictCoverageStateProviderProps = {
  areaId?: string;
  areaName?: string;
  areaShortCode?: string;
  canEdit?: boolean;
  loading?: boolean;
  instructorDistricts?: District[];
  onDistrictsUpdate?: (updatedRowData: District[]) => void;
  title?: string;
};

export type DistrictCoverageProps = Pick<
  DistrictCoverageStateProviderProps,
  "loading" | "canEdit" | "areaShortCode" | "areaName"
> & {
  districts?: RowData[];
  mode?: ViewMode;
  onConfirm?: () => void;
  onDistrictsUpdate?: (updatedRowData: RowData[]) => void;
  toggleEdit?: () => void;
  totalDistricts?: number;
  title?: string;
};

export type ViewDistrictsProps = {
  areaName?: string;
  areaShortCode?: string;
  districts?: District[];
  totalDistricts?: number;
};
